
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var React = require('react');
var PropTypes = require('prop-types');
var _require = require('react-helmet'),
  Helmet = _require.Helmet;
var connect = require('../../components/connect');
var RadioInput = require('../../components/inputs/radio');
var PackageListItem = require('../../components/package-list-item/package-list-item');
var Pagination = require('../../components/pagination/pagination');
var SearchFilterDropdown = require('../../components/dropdown/search-filter-dropdown');
var Dropdown = require('../../components/dropdown/dropdown');
var _search = require('../../../client/actions/search');
var styles = require('./search.css');

// TODO: Add icons to each button in sidebar
// const popularity = require('./popularity.svg')
// const maintenance = require('./maintenance.svg')
// const quality = require('./quality.svg')
// const optimal = require('./optimal.svg')

var NPM_SEARCH_MAX_PAGES = 300;
var SearchPage = /*#__PURE__*/function (_React$PureComponent) {
  function SearchPage() {
    _classCallCheck(this, SearchPage);
    return _callSuper(this, SearchPage, arguments);
  }
  _inherits(SearchPage, _React$PureComponent);
  return _createClass(SearchPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // focus the search element, place the cursor at the end
      var input = global.document.querySelector('input[type="search"]');
      var end = input.value.length;
      input.focus();
      input.setSelectionRange(end, end);
    }
  }, {
    key: "search",
    value: function search() {
      this.props.dispatch(_search());
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        total = _this$props.total,
        objects = _this$props.objects,
        url = _this$props.url,
        pagination = _this$props.pagination,
        _this$props$formData = _this$props.formData,
        formData = _this$props$formData === void 0 ? {} : _this$props$formData,
        hidePQM = _this$props.hidePQM;
      var displayTotal = Math.min(total, pagination.perPage * NPM_SEARCH_MAX_PAGES);
      var searchWord = formData.search && formData.search.q && formData.search.q.value;
      var sortByOption = formData.search && formData.search.sortBy && formData.search.sortBy.value;
      return [/*#__PURE__*/React.createElement("div", {
        className: hidePQM ? styles.searchTopbarContainerV2 : styles.searchTopbarContainer,
        key: "heading"
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.srOnly
      }, "Search results"), hidePQM ? SearchBarWithoutPQM({
        displayTotal: displayTotal,
        searchWord: searchWord,
        sortByOption: sortByOption
      }) : SearchBarWithPQM({
        displayTotal: displayTotal,
        url: url,
        pagination: pagination
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.main,
        key: "main"
      }, /*#__PURE__*/React.createElement(Head, {
        term: formData.search.q.value
      }), !hidePQM && /*#__PURE__*/React.createElement("aside", {
        className: styles.searchSidebar
      }, /*#__PURE__*/React.createElement(RadioInput, {
        name: "ranking",
        formId: "search",
        formData: formData,
        label: "Sort Packages",
        onChange: function onChange() {
          return _this.search();
        },
        values: [{
          label: 'Optimal',
          value: 'optimal'
        }, {
          label: 'Popularity',
          value: 'popularity'
        }, {
          label: 'Quality',
          value: 'quality'
        }, {
          label: 'Maintenance',
          value: 'maintenance'
        }],
        fieldsetClassName: styles.searchSidebarFieldset
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.packageList,
        key: "list"
      }, objects.map(function (_ref) {
        var pkg = _ref.package,
          score = _ref.score;
        return /*#__PURE__*/React.createElement(PackageListItem, {
          key: pkg.name,
          package: pkg,
          score: score,
          searchWord: searchWord,
          hidePQM: hidePQM
        });
      }), objects.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row justify-between"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.pagination
      }, /*#__PURE__*/React.createElement(Pagination, _extends({
        url: url
      }, pagination, {
        total: displayTotal,
        surround: 2
      }))))))];
    }
  }]);
}(React.PureComponent);
SearchPage.propTypes = {
  objects: PropTypes.arrayOf(PropTypes.shape({
    package: PropTypes.object.isRequired
  })).isRequired,
  partners: PropTypes.arrayOf(PropTypes.object),
  hidePQM: PropTypes.bool
};
function Head(_ref2) {
  var term = _ref2.term;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, term, " - npm search"));
}
function SearchBarWithoutPQM(_ref3) {
  var displayTotal = _ref3.displayTotal,
    searchWord = _ref3.searchWord,
    sortByOption = _ref3.sortByOption;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.searchTopbar
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: styles.searchHeading
  }, displayTotal, " packages found")), /*#__PURE__*/React.createElement("div", {
    className: styles.searchDropdownFilterContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchDropdownFilter
  }, /*#__PURE__*/React.createElement(SearchFilterDropdown, {
    text: 'Most Downloaded',
    heading: 'Sort By',
    searchWord: searchWord,
    sortByOption: sortByOption
  }))));
}
function SearchBarWithPQM(_ref4) {
  var displayTotal = _ref4.displayTotal,
    url = _ref4.url,
    pagination = _ref4.pagination;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.searchTopbar
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: styles.searchHeading
  }, displayTotal, " packages found")), /*#__PURE__*/React.createElement("div", {
    className: styles.pagination
  }, /*#__PURE__*/React.createElement(Pagination, _extends({
    url: url
  }, pagination, {
    total: displayTotal,
    surround: 2
  }))));
}
module.exports = connect()(SearchPage);
  let __hot__
  
  __registry__.register('search/search', module.exports, __hot__)
  